import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function FGWListUtilitiesTesting({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/utils/signiant-control'}
                onClick={handleDrawerToggle}
                secondary={'Using Signiant Control'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/utils/transferring-to-endpoint'}
                onClick={handleDrawerToggle}
                secondary={'Transferring Content'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/utils/testing-your-gateway-connection'}
                onClick={handleDrawerToggle}
                secondary={'Testing Your Connection'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/utils/advanced-testing'}
                onClick={handleDrawerToggle}
                secondary={'Advanced Testing'}
            />
        </List>
    );
}

FGWListUtilitiesTesting.propTypes = {
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default FGWListUtilitiesTesting;
